import {Link} from "@montana/shared/link";
import {ILink} from "@montana/models/generated/cms.interface";
import React from "react";

export interface ISeriesLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
    link: ILink;
    title: string;
}

export function SeriesLink(props: ISeriesLinkProps) {
    const {link, title, ...rest} = props;
    return (
        <Link to={link.url} className="series-link" {...rest}>{title}</Link>
    )
}